import StickySidebar from "sticky-sidebar";

export default {
	init() {
		
		const $floatingButton = document.getElementById('floating-button');
		
		if ($floatingButton) {
			new StickySidebar($floatingButton, {
				containerSelector: ".sidebar",
			})
		}

	}
}
